import React from 'react';
import './GetInTouch.css'

const GetInTouch = () => {
    return (
        <div className='bg-gradient-to-r from-orange-400 to-yellow-500 px-4 md:px-12 py-10 md:flex'>
            <div className='flex-1 mb-12 md:mb-0'>
                <h1 className='text-4xl lg:text-6xl font-semibold text-center mt-4 md:mt-10 mb-4'>We <span className='text-red-600'>like</span> to <br /> <span className='text-blue-500'>hear</span> from <span className='text-blue-500'>you</span> </h1>
                <p className='text-center'>Share your thoughts, pose a query, or simply say hello! We're here to help you.</p>
            </div>
            <div className='flex-1 md:ml-16 ml-4 '>

                <div className="mockup-phone border-primary">
                    <div className="camera"></div>
                    <div className="display">
                        <div className="artboard artboard-demo phone-1"><div className='w-full bg-white rounded-xl pb-4'>
                            <h1 className='text-center text-2xl rounded-t-xl bg-green-300 py-2 mt-0'>Let's get in touch</h1>
                            <form className=' mt-6 px-4'>
                                <div className='flex'>
                                    <div className='flex-1'>
                                        <label htmlFor="name" className='font-semibold'>Full Name</label> <br />
                                        <input type="text" name="name" id="name" className='h-8 w-32 lg:w-44 border focus:outline-none' />
                                    </div>
                                    <div className='flex-1'>
                                        <label htmlFor="subject" className='font-semibold'>Subject</label><br />
                                        <select name="subject" id="subject" className="border focus:outline-none h-8 w-full">
                                            <option disabled>Select</option>
                                            <option value='engineering'>Engineering </option>
                                            <option value='medical'>Medical </option>
                                            <option value='pharma'>Pharma </option>
                                            <option value='law'>Law </option>
                                            <option value='MBA'>MBA</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='my-4 flex'>
                                    <div className='flex-1'>
                                        <label htmlFor="email" className='font-semibold'>Email</label> <br />
                                        <input type="email" name="email" id="email" className='h-8 lg:w-40 w-28 border focus:outline-none' />
                                    </div>
                                    <div className='flex-1'>
                                        <label htmlFor="mobile" className='font-semibold'>Mobile Number</label>
                                        <input type="number" name="mobile" id="mobile" className='h-8 w-full border focus:outline-none' />
                                    </div>
                                </div>
                                <label htmlFor="message" className='font-semibold '>Message</label><br />
                                <textarea name="message" id="message" className='w-full border focus:outline-none h-32'></textarea>
                                <input type="submit" value="Submit" className='bg-green-500 hover:bg-green-600 w-full mt-16 py-2 text-white font-semibold rounded-lg cursor-pointer' />
                            </form>
                        </div></div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default GetInTouch;